<div class="filter-bg">
  <ion-row>
    <ion-col col-3 *ngFor="let filter of filtersList">
      <button ion-button block class="ion-no-margin" color="white" (click)="openFilterView(filter)" [ngClass]="{'is-filter-active':filter.isActive}">
        {{ filter.title | translate}}
        <span ion-text color="primary" [hidden]="!filter.isActive || (filter.selected <= 1 && filter.type != 'interests')">({{ filter.selected }})</span>
      </button>
    </ion-col>
  </ion-row>
</div>